import './Brand.css';
import { t } from '../../copy/strings';
import { toggleAbout } from '../../state/actions';
import { useConfig, useTvOn, useUi } from '../../state/hooks';
import { BrandLogo } from './BrandLogo';

/** Id do `h1`: alvo de foco de reserva de §5.9 (`tabindex="-1"`). */
export const BRAND_NAME_ID = 'brand-name';

/**
 * Marca (§6.2, M23): `h1` com a logo (ORD-F-022, item 3), de `alt` o nome do produto (único `h1` da página; não é
 * link; vem de VITE_PRODUCT_NAME e nunca é escrito à mão, §16.1.1 e §13.6.1), subtítulo do turno em `<time>` e
 * o botão "Sobre", que abre o `AboutDialog` a qualquer momento. Sem crédito "by …", sem logo de terceiros; redes
 * sociais só com `features.social_links` (P2, desligada: nada é renderizado). Na TV, só o nome.
 */
export function Brand() {
  const cfg = useConfig();
  const ui = useUi();
  const tv = useTvOn();
  const open = ui.aboutOpen === 'about';
  return (
    <div class="brand" data-testid="brand">
      <h1 class="brand__name" id={BRAND_NAME_ID} tabIndex={-1}>
        <BrandLogo />
      </h1>
      {!tv && (
        <span class="brand__line">
          <time class="brand__subtitle" dateTime={cfg.election_date}>
            {t('brand.subtitle')}
          </time>
          <span class="brand__sep" aria-hidden="true">
            {' · '}
          </span>
          {/* data-about-trigger: o AboutDialog devolve o foco a este gatilho quando o clique não o focou (WebKit),
              AC-15.2-06; header não importa features/about (FE §4.6), por isso o nome do atributo vai literal. */}
          <button
            type="button"
            class="brand__about"
            data-testid="brand-about"
            data-about-trigger="about"
            aria-haspopup="dialog"
            aria-expanded={open ? 'true' : 'false'}
            aria-controls="about-dialog"
            onClick={() => toggleAbout('about')}
          >
            {t('brand.about')}
          </button>
        </span>
      )}
    </div>
  );
}
